import { CircularProgress, Stack } from "@mui/material";

export const LoadingView = () => {
  return (
    <Stack
      position={"absolute"}
      width="100%"
      height="100%"
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress />
    </Stack>
  );
};
